import { Product } from '../../store/Product';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const listProducts = () => {
  return apiService.callExternalApi<Product[]>({
    url: `${API_SERVER_URL}/product/all`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
